import { render, staticRenderFns } from "./handhome5.vue?vue&type=template&id=198a4dd3"
import script from "./handhome5.vue?vue&type=script&lang=js"
export * from "./handhome5.vue?vue&type=script&lang=js"
import style0 from "./handhome5.vue?vue&type=style&index=0&id=198a4dd3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports